import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../fetch';
import utils from '../../../utils';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + '',
            status: d.status,
            //selectable: false
            disabled: !d.selected,
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('ky/base/resources/getNationalEconomy/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
            console.log('error');
        });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('/ky/base/resources/nationalEconomyTree', keywords)
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('ky/base/resources/insertNationalEconomy', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '提示信息',
                    content: (
                        <div>
                            <p>{response.message}</p>
                        </div>
                    ),
                    onOk() { },
                });
            } 
        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('ky/base/resources/updateNationalEconomy/' + id, data)
        .then(response => {
            if (response.payload.data.code === 200) {
                Modal.success({
                    title: '提示信息',
                    content: (
                        <div>
                            <p>{response.payload.data.message}</p>
                        </div>
                    ),
                    onOk() { },
                });
            } else {
                Modal.error({
                    title: '错误信息',
                    content: (
                        <div>
                            <p>{response.payload.data.message}</p>
                        </div>
                    ),
                    onOk() { },
                });
            }
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('ky/base/resources/removeNationalEconomy/', ids)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '提示信息',
                    content: (
                        <div>
                            <p>{response.message}</p>
                        </div>
                    ),
                    onOk() { },
                });
            }

            return response;
        });
}

/**
 * @method queryByLevelId
 * @param {number} id
 * @return {promise}
 */
 const queryByLevelIdAndName = (id, value) => {
    return fetch.get(`ky/project/category/queryByLevelIdAndName/${id||"0"}/${value||"null"}`, {})
    .then(response => response.payload.data)
}

const querySubjectById = (id) => {
	return fetch.post('ky/project/category/querySubjectById/' + id, {})
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const query = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('/ky/base/resources/nationalEconomyTree', keywords)
        .then(response => response.payload.data)
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove, 
    queryByLevelIdAndName,
    querySubjectById,
    query
}